import * as turf from "@turf/turf";

/**
 * Close an open GeoJSON linear ring so turf.polygon() accepts it.
 * Historically polygons coming from the new frontend are stored without
 * duplicating the first vertex at the end; turf.polygon() rejects those
 * with "First and last Position are not equivalent" and crashes the page.
 */
const closeRing = (ring: number[][]): number[][] => {
  if (ring.length === 0) return ring;
  const [fx, fy] = ring[0];
  const [lx, ly] = ring[ring.length - 1];
  return fx === lx && fy === ly ? ring : [...ring, [fx, fy]];
};

export const validatePolygonInsidePolygon = (
  polygonCoords: number[][][],
  regionPolygon: number[][][],
  minOverlapPercentage = 70
): boolean => {
  const poly = turf.polygon(polygonCoords.map(closeRing));
  const region = turf.polygon(regionPolygon.map(closeRing));

  const polygonWithinRegion = turf.booleanWithin(poly, region);
  if (polygonWithinRegion) {
    return true;
  }

  try {
    const intersection = turf.intersect(poly, region);

    if (!intersection) {
      return false;
    }

    const polyArea = turf.area(poly);
    const intersectionArea = turf.area(intersection);

    const overlapPercentage = (intersectionArea / polyArea) * 100;

    return overlapPercentage >= minOverlapPercentage;
  } catch (error) {
    console.error("Error calculating polygon overlap:", error);
    return false;
  }
};
